<template >
  <v-card>
    <v-card-title style="padding: 3px; _margin: 0px">
      <span v-if="this.tipoAna == 'PR'" class="text-h5">Nuova persona</span>
      <span v-if="this.tipoAna == 'IMP'" class="text-h5">Nuova attività</span>
      <span v-if="tipoAna == 'VR'" class="text-h5">Vedi rilievo</span>
    </v-card-title>
    <v-card-text>
      <!-- COGNOME NOME -->
      <v-row v-if="this.tipoAna == 'PR'">
        <v-col cols="6" p-0 m-0>
          <v-text-field
            label="Cognome"
            height="1.5em"
            dense
            hide-details
            v-model="newAna.cognomeRagSoc"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            label="Nome"
            height="1.5em"
            v-model="newAna.nome"
            dense
            hide-details
            clearable
          ></v-text-field> </v-col
      ></v-row>
      <!-- RAG SOC -->
      <v-row v-if="this.tipoAna == 'IMP'">
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            label="Ragione sociale"
            height="1.5em"
            v-model="newAna.cognomeRagSoc"
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <!--comune-->
      <v-row>
        <v-col cols="5">
          <v-autocomplete
            @change="handleChangeComune"
            @update:search-input="updateSearchComune"
            class="comuAutocomplete"
            p-0
            m-0
            v-model="newAna.comune"
            :items="lookupComu.items"
            label="Comune res."
            hide-details
            dense
            clearable
            no-filter
            height="3em"
          >
            <template slot="selection" slot-scope="{ item }">
              {{ item.desComune }}
            </template>

            <template slot="item" slot-scope="{ item }">
              <span class="freeListItem">
                {{ item.desComune }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="5" v-if="showLookupAc">
          <v-autocomplete
            class="comuAutocomplete"
            p-0
            m-0
            @change="acChanged"
            v-model="newAna.ac"
            :items="lookupAc.items"
            label="Via res."
            hide-details
            dense
            clearable
            :filter="filterAc"
            height="3em"
          >
            <template slot="selection" slot-scope="{ item }">
              {{ item.desAc }} - {{ item.specie }} ({{ item.prgAc }})
            </template>

            <template slot="item" slot-scope="{ item }">
              <span class="freeListItem">
                {{ item.desAc }} - {{ item.specie }} ({{ item.prgAc }})
              </span>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <!--specie e des ac custom-->

      <v-row
        v-if="!showLookupAc && (this.tipoAna == 'PR' || this.tipoAna == 'IMP')"
      >
        <v-col cols="2">
          <v-text-field
            height="1.5em"
            label="Specie"
            v-model="newAna.customSpecie"
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            height="1.5em"
            label="Des ac"
            v-model="newAna.customDesAc"
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="this.tipoAna == 'PR' || this.tipoAna == 'IMP'">
        <v-col cols="2">
          <v-text-field
            height="1.5em"
            label="Civico"
            v-model="newAna.nc"
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            height="1.5em"
            label="Interno"
            v-model="newAna.int"
            dense
            hide-details
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <!-- VEDI RILIEVO -->

      <v-layout v-if="tipoAna == 'VR'" column style="height: 90vh">
        <v-flex md6 style="overflow: auto">
          <v-data-table
            style="_border: 1px solid yellow"
            dense
            :footer-props="{ disableItemsPerPage: true }"
            hide-default-footer
            hide-default-header
            :headers="vrTable.headers"
            :items="vrTable.items"
            :items-per-page="7"
            class="elevation-1"
            :search="vrTable.search"
            :single-select="true"
            v-model="vrTable.selectedRows"
            show-select
            item-key="prgIndirizzo"
          >
            <template v-slot:top>
              <v-text-field
                class="p-2 m-1"
                style="max-width: 5rem; margin-bottom: 1.5em"
                v-model="vrTable.search"
                append-icon=""
                label="Search"
                single-line
                hide-details
                dense
                height="3em"
              ></v-text-field>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-icon class="mr-2" @click="selectVrItem(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-flex></v-layout
      >
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="ok"> OK </v-btn>
      <v-btn color="blue darken-1" text @click="cancel"> Annulla </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { comuniService } from "../services/ComuniServices.js";
import { anaService } from "../services/AnaServices.js";
import { rilieviService } from "../services/RilieviService.js";
import { utils } from "../services/Utils.js";
export default {
  name: "InsAna",
  props: ["tipoAna", "defaultPrgComu", "defaultPrgAc"],

  data() {
    return {
      vrTable: {
        search: "",

        selectedRows: [],
        headers: [
          {
            text: "Num",
            align: "start",
            sortable: false,
            filterable: true,
            value: "num",
          },
          { text: "Proprietario", value: "prop" },
          { text: "", value: "action", sortable: false },
        ],
        items: [],
      },
      lookupComu: {
        query: "",
        items: [],
      },
      lookupAc: {
        query: "",
        items: [],
      },

      vie: [],
      retVal: {},
      showLookupAc: true,
      newAna: {
        cognomeRagSoc: "",
        nome: "",
        ragSoc: "",
        cf: "",
        piva: "",
        customSpecie: "VIA",
        customDesAc: "",
        nc: "",
        int: "",
        comune: { prgComune: 0, desComune: "" },
        ac: { prgAc: 0, desAc: "via iniziale" },
      },
    };
  },
  mounted() {
    //gestito tramite v-if nel parent

    // const prgComune=this.defaultPrgComu
    //const desComune
    //this.selected.comune.prgComune=this.defaultPrgComu;
    //this.selected.ac.prgAc=this.defaultPrgAc;
    //this.selected.ac.desAc="via da selezione";
    this.retrieveComuneCorrente();
  },

  methods: {
    selectVrItem(item) {
      alert(JSON.stringify(item));
    },
    acChanged(ac) {
      if (ac == null) {
        alert(ac);
      }
      this.doLookupVrWithDetails();
    },
    showMsg(msg) {
      alert(msg);
    },

    validate() {
      if (this.tipoAna == "VR") {
        if (this.vrTable.selectedRows.length < 1) {
          this.showMsg("Selezionare una riga");
          return false;
        }
      }
      if (this.tipoAna == "PR") {
        //COGNOME
        if (utils.isNullString(this.newAna.cognomeRagSoc)) {
          this.showMsg("Campo COGNOME obbligatorio");
          return false;
        }
        //NOME
        if (utils.isNullString(this.newAna.nome)) {
          this.showMsg("Campo NOME obbligatorio");
          return false;
        }
      }
      if (this.tipoAna == "IMP") {
        //RAGIONE SOCIALE
        if (utils.isNullString(this.newAna.cognomeRagSoc)) {
          this.showMsg("Campo RAGIONE SOCIALE obbligatorio");
          return false;
        }
      }
      //CAMPO PRG AC OPPURE
      if (this.tipoAna == "IMP" || this.tipoAna == "PR") {
        if (this.newAna.comune.prgComune == this.defaultPrgComu) {
          //PRG AC
          if (this.newAna.ac.prgAc == null) {
            this.showMsg("Campo VIA obbligatorio");
            return false;
          }
        } else {
          //SPECIE
          if (utils.isNullString(this.newAna.customSpecie)) {
            this.showMsg("Campo SPECIE obbligatorio");
            return false;
          }
          //AC
          if (utils.isNullString(this.newAna.customDesAc)) {
            this.showMsg("Campo NOME VIA obbligatorio");
            return false;
          }
        }
      }

      return true;
    },
    ok() {
        if (this.validate()) {
      if (this.tipoAna == "VR") {
            const ret = {};

            ret.prg = this.vrTable.selectedRows[0].prgIndirizzo;
            ret.des= this.vrTable.selectedRows[0].num;

            
            //alert(JSON.stringify(ret));
            this.$emit("dialogClosed", ret);
      } else {
        this.salva();
      }

      
        
      }
    },
    cancel() {
      this.$emit("dialogClosed");
    },
    filterAc(item, queryText, itemText) {
      const textOne = item.desAc.toLowerCase();
      if (itemText == "ccc") {
        alert(itemText);
      }
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) == 0;
    },
    handleChangeComune(item) {
      if (item.prgComune == this.defaultPrgComu) {
        this.showLookupAc = true;
      } else {
        this.showLookupAc = false;
      }
      //alert(JSON.stringify(item));
    },
    updateSearchComune(searchInput) {
      if (searchInput != null) {
        if (this.lookupComu.query !== searchInput) {
          this.lookupComu.query = searchInput;
          this.doLookupComu(searchInput);
        }
      }
    },

    retrieveComuneCorrente() {
      comuniService.getComuneCorrente().then((x) => {
        //alert(JSON.stringify(x));
        const item = x;
        const prgComune = item.prgComune;
        const desComune = item.desComune;
        const tbd = item.tbd; //comune da importare da nc_com
        const sel = { prgComune, desComune, tbd };
        this.newAna.comune = sel;

        this.lookupComu.items = [];
        this.lookupComu.items.push(this.newAna.comune);
        //lookup ac
        this.lookupAc.items = [];
        for (let index = 0; index < x.vie.length; index++) {
          const item2 = x.vie[index];
          const prgAc = item2.prgAc;
          const desAc = item2.desAc;
          const specie = item2.specie;
          //const des = item.des;
          const lookupItem = { prgAc, desAc, specie };
          this.lookupAc.items.push(lookupItem);
          if (prgAc == this.defaultPrgAc) {
            this.newAna.ac = lookupItem;
          }
        }
        if (this.tipoAna == "VR") {
          this.doLookupVrWithDetails();
        }
      });
    },

    salva() {
      const newAna = {};
      newAna.tipoAna = this.tipoAna;
      newAna.cognomeRagSoc = this.newAna.cognomeRagSoc;
      newAna.nome = this.newAna.nome;
      newAna.prgComuneRes = this.newAna.comune.prgComune;
      newAna.prgAcRes = this.newAna.ac.prgAc;
      newAna.customSpecie = this.newAna.customSpecie;
      newAna.customDesAc = this.newAna.customDesAc;
      let nc = utils.splitNc(this.newAna.nc);
      newAna.nc = nc.nc;
      newAna.ncSub = nc.sub;
      let interno = utils.splitNc(this.newAna.int);
      newAna.interno = interno.nc;
      newAna.internoSub = interno.sub;

      anaService.insAna(newAna).then((x) => {
        if (x.outCome == "OK") {
          if (x.data.prg > 0) {
            const ret = {};

            ret.prg = x.data.prg;

            if (this.tipoAna == "PR") {
              ret.des = this.newAna.cognomeRagSoc + " " + this.newAna.nome;
            } else {
              ret.des = this.newAna.cognomeRagSoc;
            }
            //alert(JSON.stringify(ret));
            this.$emit("dialogClosed", ret);
          }
        } else {
          alert(JSON.stringify(x.message));
        }
      });
    },
    async doLookupVrWithDetails() {
      rilieviService.lookupVrWithDetails(this.newAna.ac.prgAc).then((x) => {
        //alert(this.search);
        //alert(JSON.stringify(x))
        //this.lista.items.splice(0, this.lista.items.length);
        this.vrTable.items = [];

        for (let index = 0; index < x.items.length; index++) {
          const item = x.items[index];
          const prgIndirizzo = item.prgInd;
          const num = item.desNum;
          const prop = item.propsDes;

          //const des = item.des;
          const lookupItem = { prgIndirizzo, num, prop };
          this.vrTable.items.push(lookupItem);
        }
      });
    },
    async doLookupComu(query) {
      comuniService.lookupComu(query, 1, 5).then((x) => {
        //    alert(JSON.stringify(x));
        this.lookupComu.items = [];

        for (let index = 0; index < x.items.length; index++) {
          const item = x.items[index];
          const prgComune = item.prg;
          const desComune = item.des + "(" + item.prov + ")";
          const tbd = item.tbd; //comune da importare da nc_com
          //const des = item.des;
          const lookupItem = { prgComune, desComune, tbd };
          this.lookupComu.items.push(lookupItem);
        }
      });
    },
  },
};
</script>
  

<style scoped >
.v-icon {
  font-size: 8px !important;
}
.col {
  padding-top: 2px !important;
  margin-top: 1px !important;
}
</style>

